import React from "react";
import { FormControlLabel, Checkbox as CheckboxMUI } from "@mui/material";
import { createTheme, ThemeProvider } from "@mui/material";

const theme = createTheme({
  components: {
    MuiFormControlLabel: {
      styleOverrides: {
        root: {
          width: "100%",
          height: "34px",
          margin: 0,
          padding: 0,
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: ({ ownerState, theme }) => {
          return {
            margin: "0 -4px",
            padding: "2px",
            "&.Mui-checked": {
              color: !ownerState.disabled ? "#000000" : "#999999",
            },
            "&.Mui-focusVisible": {
              backgroundColor: "#C9C9C9",
            },
            ":hover": {
              backgroundColor: "#C9C9C9",
            },
          };
        },
      },
    },
    MuiTypography: {
      styleOverrides: {
        root: {
          margin: "0 5px",
          fontSize: "13px",
          fontWeight: 700,
          width: "100%",
        },
      },
    },
  },
});

const Checkbox = React.forwardRef((props, ref) => {
  const {
    id,
    checked,
    disabled,
    name,
    sx,
    label = "",
    disableRipple = true,
    onChange = () => {},
    inputProps = {},
    onFocus = () => {},
  } = props;
  return (
    <ThemeProvider theme={theme}>
      <FormControlLabel
        control={
          <CheckboxMUI
            id={id}
            sx={sx}
            disableRipple={disableRipple}
            checked={checked}
            name={name}
            onFocus={onFocus}
            onClick={onChange}
            inputProps={inputProps}
            inputRef={ref}
            disabled={disabled}
          />
        }
        label={label}
      />
    </ThemeProvider>
  );
});

export default Checkbox;
